import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDJO9qpgx0zUqscyHhQyqk4fhgwo1Dxuhc",
  authDomain: "tcf-ai-portal.firebaseapp.com",
  projectId: "tcf-ai-portal",
  storageBucket: "tcf-ai-portal.firebasestorage.app",
  messagingSenderId: "100499942541",
  appId: "1:100499942541:web:be5c587f70494e713bc6c4",
  measurementId: "G-VC47S1BP71"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
